import React from "react";
import "./Home.css";

import Hero from "../Hero/Hero";
import OneClickSection from "../OneClickSection/OneClickSection";
import Services from "../Services/Services";
import Banner from "../Banner/Banner";
import Process from "../Process/Process";
import Strategies from "../Strategies/Strategies";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";

const Home = () => {
  return (
    <main className="home-wrapper">
      <section className="home-section hero-section">
        <Hero />
      </section>

      <section className="home-section light-section">
        <OneClickSection />
      </section>

      <section className="home-section">
        <div className="section-intro">
          <h2>Services we offer</h2>
          <p>
            Explore how we help teams plan and run digital marketing. Every engagement is scoped in writing; we do not
            promise specific rankings, leads, or revenue.
          </p>
        </div>
        <Services />
      </section>

      <section className="home-section band-section">
        <div className="section-intro section-intro--on-light">
          <h2>How we work with ad platforms</h2>
          <p>
            We aim for transparent landing pages, accurate claims, and clear privacy disclosures—aligned with common
            expectations for Google Ads and similar channels.
          </p>
        </div>
        <Banner />
      </section>

      <section className="home-section light-section">
        <div className="section-intro">
          <h2>Delivery process</h2>
          <p>
            A practical workflow from discovery to reporting. Timelines and deliverables depend on your goals, budget,
            and what you already have in place.
          </p>
        </div>
        <Process />
      </section>

      <section className="home-section">
        <div className="section-intro">
          <h2>Principles</h2>
          <p>
            These ideas guide our recommendations, contracts, and how we describe third-party platforms and tools.
          </p>
        </div>
        <Strategies />
      </section>

      <section className="home-section light-section">
        <WhyChooseUs />
      </section>
    </main>
  );
};

export default Home;
